export const scrollToBottom = (scrollContainerRef) => {
  if (!scrollContainerRef?.current) return;

  requestAnimationFrame(() => {
    const container = scrollContainerRef.current;
    container.scrollTo({
      top: container.scrollHeight,
      behavior: "smooth",
    });
  });
};
